// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
    report: path(ROOTS_DASHBOARD, "/report"),
  },

  desigination: {
    root: path(ROOTS_DASHBOARD, "/desigination"),
    new: path(ROOTS_DASHBOARD, "/desigination/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/desigination/${id}/edit`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, "/user"),
    new: path(ROOTS_DASHBOARD, "/user/new"),
    list: path(ROOTS_DASHBOARD, "/user/list"),
    cards: path(ROOTS_DASHBOARD, "/user/cards"),
    profile: path(ROOTS_DASHBOARD, "/user/profile"),
    account: path(ROOTS_DASHBOARD, "/user/account"),
    edit: (id) => path(ROOTS_DASHBOARD, `/user/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/user/${id}/replicate`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  menu: {
    list: path(ROOTS_DASHBOARD, "/menu/list"),
    newCategory: path(ROOTS_DASHBOARD, "/category/new"),
    newItem: path(ROOTS_DASHBOARD, "/item/new"),
    display: path(ROOTS_DASHBOARD, "/menu/display"),
  },
    item: {
    new: path(ROOTS_DASHBOARD, "/item/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/item/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/item/${id}/replicate`),
  },
  category: {
    new: path(ROOTS_DASHBOARD, "/category/new"),
    edit: (id) => path(ROOTS_DASHBOARD, `/category/${id}/edit`),
    replicate: (id) => path(ROOTS_DASHBOARD, `/category/${id}/replicate`),
  },


  customer: {
    list: path(ROOTS_DASHBOARD, "/customer/list"),
    new: path(ROOTS_DASHBOARD, "/customer/new"),
    account: path(ROOTS_DASHBOARD, "/customer/account"),
    edit: (id) => path(ROOTS_DASHBOARD, `/customer/${id}/edit`),
    profile: (id) => path(ROOTS_DASHBOARD, `/customer/${id}/profile`),
  },

  store: {
    themeList: path(ROOTS_DASHBOARD, "/store/themes"),
    new: path(ROOTS_DASHBOARD, "/store/new"),
    themePreview: (themeName) => path(ROOTS_DASHBOARD, `/store/themes/Preview/${themeName}`),
    elementditTheme: (themeName) => path(ROOTS_DASHBOARD, `/store/themes/${themeName}/edit`),
  },

  page: {
    list: path(ROOTS_DASHBOARD, "/page/list"),
    new: path(ROOTS_DASHBOARD, "/page/new"),
    account: path(ROOTS_DASHBOARD, "/page/account"),
    edit: (id) => path(ROOTS_DASHBOARD, `/page/${id}/edit`),
    profile: (id) => path(ROOTS_DASHBOARD, `/page/${id}/profile`),
  },


  settings: {
    list: path(ROOTS_DASHBOARD, "/settings/list"),
    new: path(ROOTS_DASHBOARD, "/settings/new"),
    account: path(ROOTS_DASHBOARD, "/settings/account"),
    kds: path(ROOTS_DASHBOARD, "/settings/kds"),
    edit: (id) => path(ROOTS_DASHBOARD, `/settings/${id}/edit`),
  },
};

export const PATH_DOCS = {
  root: "https://docs.minimals.cc",
  changelog: "https://docs.minimals.cc/changelog",
};

export const PATH_ZONE_ON_STORE = "https://mui.com/store/items/zone-landing-page/";

export const PATH_MINIMAL_ON_STORE = "https://mui.com/store/items/minimal-dashboard/";

export const PATH_FREE_VERSION = "https://mui.com/store/items/minimal-dashboard-free/";

export const PATH_FIGMA_PREVIEW =
  "https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1";
